(() => {
  'use strict';
  if (window.bestekAboutCinemaInstalled) return;
  window.bestekAboutCinemaInstalled = true;
  const initialized = new WeakSet();
  const DURATION = 21000;
  function initialize(root) {
    if (initialized.has(root)) return;
    initialized.add(root);
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const effects = new Set(), observers = [];
    const enabled = () => root.dataset.motion === 'true' && !reduced.matches;
    const animate = (node,frames,options) => {
      if (!enabled() || !node.animate) return;
      const animation = node.animate(frames,options);
      effects.add(animation);
      animation.finished.then(()=>effects.delete(animation)).catch(()=>effects.delete(animation));
    };
    if ('IntersectionObserver' in window) {
      const reveal = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          const node=entry.target;
          node.classList.add('ba-visible');
          if(node.matches('[data-ba-reveal]')) animate(node,[{opacity:.45,transform:'translateY(14px)'},{opacity:1,transform:'none'}],{duration:650,easing:'cubic-bezier(.16,1,.3,1)'});
          reveal.unobserve(node);
        });
      },{threshold:.18});
      root.querySelectorAll('[data-ba-reveal],[data-ba-milestone]').forEach(n=>reveal.observe(n));
      observers.push(reveal);
    }
    const film=root.querySelector('[data-ba-film]');
    const video=film?.querySelector('.ba-film-video');
    let filmEffects=[], entered=false, inView=false;
    function sync() {
      const running=enabled() && inView && !document.hidden;
      if(video){if(running)video.play().catch(()=>{});else video.pause();}
      else filmEffects.forEach(a=>running?a.play():a.pause());
      if(film) film.dataset.filmState=running?'playing':'paused';
    }
    function clearFilm() {
      filmEffects.forEach(a=>a.cancel());filmEffects=[];
      if(video){video.pause();video.currentTime=0;}
      entered=false;
      if(film)film.dataset.filmState='still';
    }
    function buildFilm() {
      if(!film || !enabled() || (!video && !Element.prototype.animate))return;
      filmEffects.forEach(a=>a.cancel());filmEffects=[];
      entered=true;
      if(video){video.currentTime=0;sync();return;}
      const add=(node,frames)=>{
        const a=node.animate(frames,{duration:DURATION,fill:'both',easing:'linear',iterations:Infinity});
        // Changing motion preferences cancels every track.
        a.finished.catch(()=>{});
        a.pause();filmEffects.push(a);return a;
      };
      film.querySelectorAll('[data-film-shot]').forEach((shot,index)=>{
        const frames=index===0?[{opacity:1,offset:0},{opacity:1,offset:.28},{opacity:0,offset:.34},{opacity:0,offset:1}]:index===1?[{opacity:0,offset:0},{opacity:0,offset:.28},{opacity:1,offset:.34},{opacity:1,offset:.61},{opacity:0,offset:.67},{opacity:0,offset:1}]:[{opacity:0,offset:0},{opacity:0,offset:.61},{opacity:1,offset:.67},{opacity:1,offset:1}];
        add(shot,frames);
        const start=index*.305, end=Math.min(1,start+.39);
        add(shot.querySelector('img'),[{transform:'scale(1.055) translateX(-.4%)',offset:0},{transform:'scale(1.055) translateX(-.4%)',offset:start},{transform:'scale(1) translateX(0)',offset:end},{transform:'scale(1) translateX(0)',offset:1}]);
        const text=shot.querySelector('.ba-film-text');
        add(text,[{transform:'translateY(24px)',offset:0},{transform:'translateY(24px)',offset:start},{transform:'translateY(0)',offset:Math.min(1,start+.095)},{transform:'translateY(0)',offset:1}]);
      });
      sync();
    }
    const preferenceChanged=()=>{
      if(!enabled()){effects.forEach(a=>a.cancel());clearFilm();}
      else if(inView && !entered)buildFilm();
    };
    const visibilityChanged=()=>{effects.forEach(a=>document.hidden?a.pause():a.play());sync();};
    const mobileBreakpoint=matchMedia('(max-width: 480px)');
    const sourceChanged=()=>{if(video?.querySelector('source[media]')){video.load();sync();}};
    mobileBreakpoint.addEventListener('change',sourceChanged);
    if(film && 'IntersectionObserver' in window){
      const watcher=new IntersectionObserver(entries=>{const entry=entries[0];inView=entry.isIntersecting;if(inView && !entered)buildFilm();else sync();},{threshold:.18});
      watcher.observe(film);observers.push(watcher);
    }
    reduced.addEventListener('change',preferenceChanged);
    document.addEventListener('visibilitychange',visibilityChanged);
    root.bestekAboutCleanup=()=>{
      observers.forEach(o=>o.disconnect());effects.forEach(a=>a.cancel());clearFilm();
      reduced.removeEventListener('change',preferenceChanged);document.removeEventListener('visibilitychange',visibilityChanged);mobileBreakpoint.removeEventListener('change',sourceChanged);
      initialized.delete(root);
    };
  }
  const boot=(scope=document)=>{if(scope.matches?.('[data-about-journey]'))initialize(scope);scope.querySelectorAll('[data-about-journey]').forEach(initialize);};
  boot();
  document.addEventListener('shopify:section:load',e=>boot(e.target));
  document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-about-journey]').forEach(root=>root.bestekAboutCleanup?.()));
})();
